
  import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
  import { ExcelService } from '../common/API/excel.service';
  import { Router, ActivatedRoute } from '@angular/router';
  // import { ApiService } from '../../Common/API/api.service';
  import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
  import * as XLSX from 'ts-xlsx';
  import { NotifierService } from 'angular-notifier';
  import { WorkBook } from 'xlsx';
  import * as $ from 'jquery';
  import { NgxSpinnerService } from 'ngx-spinner';
  import { BackRestrict } from '../common/backRestrict'
  import { CommonService } from '../Services/common.service';
  import { ApiService } from '../common/API/api.service';
  import { MatPaginator, MatSort, MatTableDataSource, ErrorStateMatcher } from '@angular/material';
  import { filter } from 'rxjs-compat/operator/filter';
  import { fillProperties } from '@angular/core/src/util/property';
 // import {DeviceLocationModel } from '../Models/DeviceLocationData';
  import { DatePipe } from '@angular/common';


  
  declare var config;
  
  @Component({
    selector: 'app-upload-location',
    templateUrl: './upload-location.component.html',
    styleUrls: ['./upload-location.component.css']
  })
  export class UploadLocationComponent implements OnInit {
    @ViewChild('fileUpload') fileUpload: ElementRef;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('openBankModel') openBankModel: ElementRef;
    @ViewChild('openSuccessModel') openSuccessModel: ElementRef;
    @ViewChild('Enterprise') Enterprise: any;
    @ViewChild('stores') stores: any;
    public IsOverridePhoneModel: false;
    displayedColumns: string[] = ['EnterprisePartner','ChannelType','DealerID' ,'StoreName', 'StoreAddress', 'zipcode','EmailAddress', 'City','ContactNumber' ];

  
    public Enterprisedata = [];
    public Enterprisedatas = [];
    Enterpriselist: any;
    public dataTableID: any = false;
    //EnterprisePartnerlist: any;
    public selectedDeviceVendorInPage: any;
    public data = [];
    RetailStores: any;
    searchdata:any;
    public dataSource: any;
    public arrayBuffer: any;
    public excelSheetData: any[];
    public uploadresponse:any[];
    public ExcelSheet: any;
    public status:any;
    public readonly notifier: NotifierService;
    userinfo: any;
    ChoosefileName: any;
    public EnterprisePartnerID: any;
    public EnterprisePartnerIDS:any;
    public EnterpriseID: any;
    public CurrencyName: any;
    public showexcelSheetData = [];
    public SuccessfullyUplodedList = [];
    public UnSuccessfullyUplodedList = [];
   // public devicelocation: DeviceLocationModel[] = [];
    AllList: [];
    public onSuccess: boolean;
    public successData: boolean;
    public LogFound: boolean = false;
    public Alldata = [];
    form: FormGroup;
    logform: FormGroup;
    excelData: any;
    empty:any;
    ExcelFilterData = [];
    unsuccessdata = [];
    FailLogs: boolean;
    public disabledexportBtn: boolean = true;
    FailModal: boolean;
    Successmodal: boolean;
    //Data based on category
    OriginalDeviceData: any;
    DeviceCategory: any;
    DeviceCategoryID: any;
    vendorKeyword = 'Store';
    EnnterpriceKeyword='EnterprisePartner';
    
    private matdatasource: any;

    public StoreName: any;
    public StoreAddress: any;
    public ZipCode: any;
    public City: any;
    public StorePassword: any;


    public Color: any;
    public SKU: any;
    error: boolean =  false;
    errorMassageSearchTxt: any;
    Storelist: any;
    StorelistData: any;
    EnterprisePartners: string;
    Storelists: any;
    storeEnable: boolean = true;
    successLogs: boolean = false;
    ErrorLogs: boolean = false;
    EnterpriseIDS: any;


  
    constructor(private _service: CommonService, private router: Router,
      private excelService: ExcelService, private formbuilder: FormBuilder, notifierService: NotifierService
      , private spinner: NgxSpinnerService, private backrestrict: BackRestrict, private renderer: Renderer2, private _apiService: ApiService) {
     
  
      this.logform = formbuilder.group({
        StoreName: [null],
        StoreAddress: [null],
        ZipCode: [null],
        City: [null],
        StorePassword: [null],
      
      });
      this.notifier = notifierService;
    }
    public pageSizeOptions = [5, 10, 15, 20];
  public pageSize = 10;
  public length = 10;
    ngOnInit() {
      debugger
      this.excelSheetData = [];
      this.ExcelFilterData = [];
      this.unsuccessdata = [];
      this.uploadresponse = [];
      this.backrestrict.clearBrowserBackHistory();
      this.onSuccess = false;
      this.userinfo = JSON.parse(sessionStorage.getItem('userinfo'));
      this.EnterprisePartnerID = 0;
      this.EnterprisePartnerIDS = 0;
      this.DeviceCategoryID = 1;
      this.EnterpriseID = 0;
      this.EnterpriseIDS = 0;
      this.Enterprise = config.Enterprise;
      this.CurrencyName = "US Dollar";
      this.ChoosefileName = "Choose file";
      this.GetRetailStoreList();
       this.getEnterprise_EnterprisePartner();
      // this.GetDeviceCategory();
      // this.Enterprisedata = [
      //   { EnterprisePartnerID: 1, EnterprisePartner: 'Quick Repair' }
      // ]
    }
    onChangeEnterprise(event) {
      debugger
  this.getEnterprise_EnterprisePartner();
    }
  

    onFileChanged(event) {
      debugger
      this.onSuccess = false;
      this.successLogs = false;
      this.ErrorLogs = false;
      this.unsuccessdata = [];
      this.excelSheetData = [];
      this.ExcelFilterData = [];
      this.uploadresponse=[];
        if (event.target.files[0] != undefined && event.target.files[0].name.split('.').pop() === 'xlsx') {
          this.spinner.show();
          this.ChoosefileName = event.target.files[0].name;
          this.ExcelSheet = event.target.files[0];
          this.getExcelFile();
        }
        else {
          this.notifier.notify('error', 'Please choose excel file');
          this.fileUpload.nativeElement.value = '';
          this.ChoosefileName = "Choose file";
        }
      }
      getExcelFile() {
        debugger
        
        let fileReader = new FileReader();
        fileReader.onload = (e) => {
          this.arrayBuffer = fileReader.result;
          var data = new Uint8Array(this.arrayBuffer);
          var arr = new Array();
          for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
          var bstr = arr.join('');
          let workbook: WorkBook = XLSX.read(bstr, { type: 'binary' });
          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];
          var excel_data = XLSX.utils.sheet_to_json(worksheet, { raw: false });
          this.excelSheetData = [];
          excel_data.forEach(current_value => {
               var randomstring = Math.random().toString(36).slice(-8);
            const uploaddevicelocation = {
              DealerID:current_value['DealerID'],
              StoreName :current_value['StoreName'],
              StoreAddress :current_value['StoreAddress'],
              City :current_value['City'],
              PostalCode :current_value['PostalCode'],
              ContactNumber :current_value['ContactNumber'],
              EmailAddress   :current_value['EmailAddress'],
          
         
      
            };
            this.excelSheetData.push(uploaddevicelocation);
          });
    
          this.excelData = this.excelSheetData;
          debugger
       
           if ( excel_data.length < 1 || this.excelData[0].StoreName === undefined || this.excelData[0].StoreName === '') {
            this.fileUpload.nativeElement.value = '';
             this.notifier.notify('error', 'Excel is not in proper format');
             this.excelSheetData = [];
             this.excelData =[];
             this.ExcelSheet=[];
             this.clearFiledta()
             
           }
           this.spinner.hide();
         
        
        }
        if ($('#reading_txt').val(this.ExcelSheet.name) === '') {
    
          $('#reading_txt').val(this.ExcelSheet.name);
        }
        fileReader.readAsArrayBuffer(this.ExcelSheet);
      }
    


      password_generator(len) {
        len = len - 1;
        var length = (len)?(len):(10);
        var string = "abcdefghijklmnpqrstuvwxyz"; //to upper 
        var numeric = '123456789';
        var punctuation = '';
        var password = "";
        var character = "";
        var crunch = true;
        while( password.length<length ) {
         var   entity1 = Math.ceil(string.length * Math.random()*Math.random());
         var entity2 = Math.ceil(numeric.length * Math.random()*Math.random());
         var entity3 = Math.ceil(punctuation.length * Math.random()*Math.random());
         var hold = string.charAt( entity1 );
            hold = (password.length%2==0)?(hold.toUpperCase()):(hold);
            character += hold;
            character += numeric.charAt( entity2 );
            character += punctuation.charAt( entity3 );
            password = character;
        }
        password=password.split('').sort(function(){return 0.5-Math.random()}).join('');
        var Mid = len/2;
        return  password.substring(0,Mid)+"@"+ password.substring(Mid,len);
    }
    

      Upload() {
        debugger
        if(this.EnterprisePartnerIDS == 0 || this.EnterprisePartnerIDS == null || this.EnterprisePartnerIDS == undefined || this.EnterprisePartnerIDS == '')
        {
          this.error = true;
          this.errorMassageSearchTxt = 'Select Enterprise Parter';
        }
        else{
        this.spinner.show();
        this.FailLogs = false;
        this.onSuccess = false;
        this.successData = false;
        var _ValidData = this.excelData
        this.UnSuccessfullyUplodedList = this.unsuccessdata;
        debugger
        this.Alldata = this.excelSheetData.map(element => {
          return {
            DealerID :element.DealerID === undefined ? '': element.DealerID ,
            StoreName :element.StoreName === undefined ? '': element.StoreName ,
            StoreAddress :element.StoreAddress === undefined ? '': element.StoreAddress ,
            City :element.City === undefined ? '': element.City,
            PostalCode :element.PostalCode === undefined ? '': element.PostalCode,
            ContactNumber :element.ContactNumber === undefined ? '': element.ContactNumber,
            EmailAddress :element.EmailAddress === undefined ? '': element.EmailAddress,
            StorePassword :this.password_generator(10)

          
            
            
            
          };
        });
      
        var parameters=
        {
          ExcelData:this.Alldata,
          EnterprisePartnerID: this.EnterprisePartnerIDS,
        }
        if (this.excelData != null && this.excelData.length > 0) {
          
          this._service.PostPartner(parameters , 'api/uploadRetailStores').then((result: any) => {
            
            this.clearFiledta();
            if (result !== null && result.length > 0 && result[0].Response) {
              debugger
             // this.uploadresponse=result;
              this.onSuccess = true;
              this.SuccessfullyUplodedList = [];
              this.UnSuccessfullyUplodedList=[];
              for (var i = 0; i < result.length; i++) {
                if (result[i].Response.includes('Success')) {
                  this.SuccessfullyUplodedList.push(result[i]);
                }
                else if (result[i].Response.includes('Error'))
                {
                this.UnSuccessfullyUplodedList.push(result[i]);

                }
              };
              if(this.SuccessfullyUplodedList.length > 0 && this.UnSuccessfullyUplodedList.length > 0)              {
this.successLogs = true;
this.ErrorLogs = true;

              }
              else if(this.UnSuccessfullyUplodedList.length > 0)
              {
this.ErrorLogs = true;
              }
              else if(this.SuccessfullyUplodedList.length > 0 ){
                this.successLogs = true;
            
              }
              else{
                this.successLogs = false;
                this.ErrorLogs = false;
              }

             
              this.notifier.notify('success', 'The file upload is done');
            // if(this.successData == true)
            // {
            //   this.spinner.hide();
            //   this.notifier.notify('success', 'Store uploaded successfully ');
            // }
            // else if(this.status == 'logs')
            // {
            //   this.spinner.hide();
            //   this.notifier.notify('warning', 'Store uploaded with some already existing Stores logs ');

            // }
            // else if(this.status == 'Existing')
            // {
            //   this.spinner.hide();
            //   this.notifier.notify('warning', 'Store already exists');
            // }
            // else if(this.status == 'empty')
            // {
            //   this.spinner.hide();
            //   this.notifier.notify('warning', 'Store/Address/City is empty');
            // }
            // else if(this.successData == false)
            // {
            //   this.spinner.hide();
            //   this.notifier.notify('error', 'Store not uploaded due to wrong data or missing data');

            // }
            // else {
            //     this.onSuccess = false;
            //     this.spinner.hide();
            //     this.notifier.notify('error', 'Store not uploaded');
            //   }
               this.GetRetailStoreList();
         
            }
            else {
              this.clearFiledta();
              //  console.log(result);
              this.spinner.hide();
              this.notifier.notify('error', 'Something went wrong');
            }
           
          },
            error => {
              this.spinner.hide();
              console.log(error);
              this.clearFiledta();
              this.notifier.notify('error', 'An error occured');
            });
        }
        else {
          this.spinner.hide();
          this.clearFiledta();
          this.onSuccess = true;
          this.FailLogs = true;
          this.notifier.notify('warning', 'Device Location not uploaded with some fail Logs');
        }

      }
       }

      clearFiledta() {
        this.excelSheetData = [];
        this.fileUpload.nativeElement.value = '';
        this.ChoosefileName = "Choose file";
      }
    
      Clear() {
        this.excelSheetData = [];
        this.uploadresponse=[];
        this.fileUpload.nativeElement.value = '';
        this.onSuccess = false;
        this.ChoosefileName = "Choose file";
        this.EnterprisePartnerID = 0;
        this.EnterprisePartnerIDS =0;
        this.DeviceCategoryID = 1;
        this.disabledexportBtn = true;
        this.selectedDeviceVendorInPage='';
        this.EnterprisePartners ='';
        this.error = false;
        this.RetailStores='';
        this.Storelist='';
        this.Enterpriselist='';
        this.Enterprisedata =[];
        this.Enterprisedatas =[];
        this.successLogs = false;
        this.ErrorLogs = false;
        this.EnterpriseID = "0";
        this.EnterpriseIDS = "0";
        this.Enterprise = config.Enterprise;
        this.closeDeviceList();
        
      }



      exportAsXLSX() {
        debugger
        //this.GetModelDetail();
        let _ExportAgedDevices = [
          


          { DealerID :'',StoreName:'',StoreAddress:'',  City:'',PostalCode:'',ContactNumber:'' ,EmailAddress:''
           } ];
      
        this.excelService.exportAsExcelFile(_ExportAgedDevices, 'StoreDetails')
      }

 ShowerrorLogs()
{
  debugger
  if(this.uploadresponse.length!=0)
  {
    this.LogFound=true;
  }
  let el: HTMLElement = this.openBankModel.nativeElement as HTMLElement;
  el.click();


}
ShowSuccessLogs()
{
  debugger
  if(this.uploadresponse.length!=0)
  {
    this.LogFound=true;
  }
  let el: HTMLElement = this.openSuccessModel.nativeElement as HTMLElement;
  el.click();


}

getEnterprise_EnterprisePartner() {
  debugger
  this.spinner.show();
  this._apiService.get(config.WebApiPath + 'api/support-tool/get-store').subscribe(result => {
   debugger
    if (result.IsSuccess) {
      this.Enterpriselist = (result.Data.Table2.filter(X => X.IsActive !== false));
      this.Storelists = (result.Data.Table.filter(X => X.IsActive !== false));
      

      this.Enterprisedata = result.Data.Table2.filter(X => X.EnterpriseID == this.EnterpriseID && X.IsActive !== false);
      this.Enterprisedatas = result.Data.Table2.filter(X => X.EnterpriseID == this.EnterpriseIDS && X.IsActive !== false);
      // this.SubscriberList = result.Data.Table3;
      this.spinner.hide();
    }
  },
    error => {
      this.spinner.hide();
      console.log(error);
    }
  );
}
GetRetailStoreList() {
  
debugger
  
  this.spinner.show();
  this.matdatasource = new MatTableDataSource([]);
  this._apiService.get(config.WebApiPath + 'api/support-tool/GetStoresInfo').subscribe(result => {
    
    console.log(result);
    if (result.Data.length > 0) {
      this.RetailStores = result.Data;
      this.matdatasource = this.RetailStores;
      this.dataSource = new MatTableDataSource(this.RetailStores);
      setTimeout(() => { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort }, 100);
    this.dataSource.sort = this.sort;
    this.spinner.hide();
    }
    else {
      this.spinner.hide();
    }
  },
    error => {
      console.log(error);
      this.spinner.hide();
    }
  );
}
selectVendorData(event) {
  debugger
  
  this.searchdata = this.RetailStores.filter(x => x.StoreName == event.Store);
  this.dataSource = new MatTableDataSource(this.searchdata);
  setTimeout(() => { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort }, 100);
  this.dataSource.sort = this.sort;
}

selectEnterpriceData(event) {
  debugger
  this.storeEnable = false;
  this.selectedDeviceVendorInPage ='';
  this.Storelist = '';
  
  this.searchdata = this.RetailStores.filter(x => x.EnterprisePartner == event.target.value);
  this.Storelist = this.Storelists.filter(x => x.EnterprisePartner == event.target.value);
  //this.Storelist = '';
 // Storelists
  //this.Storelist = this.StorelistData;
  this.dataSource = new MatTableDataSource(this.searchdata);
  setTimeout(() => { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort }, 100);
  this.dataSource.sort = this.sort;
}
    
close(){
 
}
closeDeviceList() {
debugger
 // this.storeEnable =true;
  this.searchdata ='';
  this.Storelist =[];
  this.Enterpriselist= '';
  this.RetailStores='';
  this.selectedDeviceVendorInPage='';
  this.storeEnable =true;
  // this.Enterprise.searchInput.nativeElement.value  =''
  this.stores.searchInput.nativeElement.value  =''
  this.GetRetailStoreList();
  this.getEnterprise_EnterprisePartner();
 
  
}
    }

  